import { baseUrl } from '../tokens'

export default `
.DsFlag-root {
    display: inline-block;
    background-repeat: no-repeat;
    vertical-align: middle;
}

.DsFlag-small {
    width: 16px;
    height: 16px;
    background-size: 301px;
    background-image: url(${baseUrl}images/flags-16-sprite.png?20250204);
}

.DsFlag-large {
    width: 31px;
    height: 25px;
    background-size: 556px 520px;
    background-image: url(${baseUrl}images/flags-32-sprite.png?20250204);
    border-radius: 10%;
}
`
